import React from "react";
import axios from "axios";
import { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import AsyncSelect from 'react-select/async';
import { Button, Icon } from "semantic-ui-react";
import { useMyGlobal } from "./GlobalData";
import LZString from 'lz-string';
import dataDestinasi from '../assets/data.json'

const AddressForm = ({ showModal, getUserAddress, isFirstAddress, editData, setUserAddress, cityOption, setSubmittedAddress, isCashier = '0' }) => {
    const [optionDestnation, setOptionDestination] = useState([])
    const [idDestination, setIdDestination] = useState('')
    const [destination, setDestination] = useState('')
    const [idCustomer, setIdCustomer] = useState('')
    const [allDestination, setAllDestination] = useState([])
    const [recipientName, setrecipientName] = useState('')
    const [celularNumber, setCelularNumber] = useState('')
    const [addressLabel, setAddressLabel] = useState('')
    const [addressDetail, setAddressDetail] = useState('')
    const [addressDetailDua, setAddressDetailDua] = useState('')
    const [infoName, setInfoName] = useState('')
    const [infoEmail, setInfoEmail] = useState('')
    const [infoPhone, setInfoPhone] = useState('')
    const [zipCode, setZipCode] = useState('')
    const [isDefault, setIsDefault] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [checkBoxState, setCheckBoxState] = useState(true)
    const [initialValue, setInitialValue] = useState(
        editData
            ? { label: editData.destination, value: editData.idDestination }
            : null
    );
    const { token } = useMyGlobal()

    const generateDestinationOption = async () => {
        let option = []
        // await axios({
        //     method: 'GET',
        //     url: `${global.SRV}api_rudrunner/controler/courier.php/?index=1`,
        //     headers: {
        //         'Content-Type': 'application/x-www-form-urlencoded',
        //         'Authorization': token
        //     }
        // })
        //     .then((response) => {
        //         if (response.data.length > 0) {
        //             response.data.map((item, index) => {
        //                 option.push({
        //                     label: `${item.sub_district}, ${item.district}, ${item.province}`,
        //                     value: item.id_destination,
        //                     zip_code: item.zip_code
        //                 })
        //             })
        //         }
        //     })
        //     .catch(err => console.log(err))
        dataDestinasi.map((item, index) => {
            option.push({
                label: `${item.sub_district}, ${item.district}, ${item.city}, ${item.province}`,
                value: item.id_destination,
                zip_code: item.zip_code
            })
        })
        setOptionDestination(option)


        // GA PERLU SIMPAN LAGI DI LOCSTORAGE
        // try {
        //     // Kompresi data dan simpan di localStorage
        //     const compressedData = LZString.compressToBase64(JSON.stringify(option));
        //     localStorage.setItem('_destination', compressedData);
        // } catch (error) {
        //     console.error('Error during compression and storage:', error);
        // }
    }

    const handleReset = () => {
        setrecipientName("");
        setCelularNumber("");
        setAddressLabel("");
        setIdDestination(null);
        setDestination("");
        setZipCode("");
        setAddressDetail("");
        setAddressDetailDua("");
        setInfoName("");
        setInfoEmail("");
        setInfoPhone("");
        setIsDefault(isFirstAddress ? 1 : 0);
    };


    const filterDestin = (inputValue) => {
        return optionDestnation.filter((i) =>
            i.label.toLowerCase().includes(inputValue.toLowerCase())
        )
    }

    const promiseOptionsDestination = (inputValue) => (
        new Promise((resolve) => {
            setTimeout(() => {
                resolve(filterDestin(inputValue));
            }, 1000);
        })
    );

    const getZipCode = (destination) => {
        if (typeof cityOption !== 'undefined') {
            const postalCode = cityOption.filter((i) => i.value === destination).map(i => i.zip_code)
            setZipCode(postalCode[0])
        } else {
            const postalCode = optionDestnation.filter((i) => i.value === destination).map(i => i.zip_code)
            setZipCode(postalCode[0])
        }
    }

    
    const handleSubmit = (e, isFirstAddr) => {
        e.preventDefault()
        const param = new URLSearchParams()

        param.append('recipient_name', recipientName)
        param.append('celular_number', celularNumber)
        param.append('address_label', addressLabel)
        param.append('id_destination', idDestination)
        param.append('zip_code', zipCode)
        param.append('info_name', infoName)
        param.append('info_email', infoEmail)
        param.append('info_phone', infoPhone)
        param.append('address_detail', addressDetail)
        param.append('address_detail_dua', addressDetailDua)
        param.append('id_customer', idCustomer)
        param.append('id_address', (editData) ? editData.id_address : '')

        setIsLoading(true)

        const handleSuccess = () => {
            getUserAddress(idCustomer)
            showModal(false)
            setIsLoading(false)
        }

        const handleError = (error) => {
            setIsLoading(false)

            if (error.code === 'ECONNABORTED') {
                alert("Your internet connection seems slow or unstable. Please refresh the page and try again.")
            } else {
                alert("Your internet connection looks unstable. Please refresh the page and try again.")
                console.error(error)
            }
        }

        if (editData) {
            axios({
                method: "POST",
                url: `${global.SRV}api_rudrunner/controler/customer.php?index=5`,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': token
                },
                data: param
            })
            .then(handleSuccess)
            .catch(handleError)

        } else {
            if (idDestination != '' && destination != '' && zipCode != '') {
                axios({
                    method: "POST",
                    url: `${global.SRV}api_rudrunner/controler/customer.php?index=2`,
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Authorization': token
                    },
                    data: param
                })
                .then(handleSuccess)
                .catch(handleError)
            } else {
                setIsLoading(false)
                alert("Please select sub district, zip code and address")
            }
        }
    }

    useEffect(() => {
        // generateDestinationOption(); 
        setIdCustomer(JSON.parse(localStorage.getItem('loginDataRr')).id)// HARUS DI CEK ULANG TAKUTNYA AKSES ID CUSTOMER LAIN (NANTI KACAU EDIT ALAMAT ORANG)
        if (editData) {
            let d = editData
            setrecipientName(d.recipient_name)
            setCelularNumber(d.celular_number)
            setAddressLabel(d.address_label)
            setIdDestination(d.id_destination)
            setZipCode(d.zip_code)
            setAddressDetail(d.address_detail)
            setAddressDetailDua(d.address_detail_dua)
            // setInfoName(d.info_name)
            // setInfoEmail(d.info_email)
            // setInfoPhone(d.info_phone)
        }


        // if (localStorage.getItem('_destination') == null) {
        generateDestinationOption()
        // } else {
        //     let compressedData = localStorage.getItem('_destination');
        //     // Dekompresi data dan set ke state (menggunakan setState sebagai contoh)
        //     try {
        //         const compressedData = localStorage.getItem('_destination');
        //         const decompressedData = JSON.parse(LZString.decompressFromBase64(compressedData));
        //         setOptionDestination(decompressedData);
        //     } catch (error) {
        //         console.error('Error during decompression:', error);
        //     }
        // }

    }, [])

    return (
        <section>
            <Form onSubmit={(e) => handleSubmit(e, isFirstAddress)}>
                <Row className="mb-3">
                    <Col sm={12} md={12}>
                        <Form.Group>
                            <Form.Label>Recipient Name</Form.Label>
                            <Form.Control type="text" maxLength={22} minLength={3} placeholder="Your Complete Name" value={recipientName} onChange={(e) => setrecipientName(e.target.value)} required />
                            <Form.Text>Max character (22)</Form.Text>
                        </Form.Group>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col sm={12} md={12}>
                        <Form.Group>
                            <Form.Label>Celular Number</Form.Label>
                            <Form.Control type="number" maxLength={15} minLength={10} placeholder="Celular Number" value={celularNumber} onChange={(e) => setCelularNumber(e.target.value)} required />
                        </Form.Group>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col sm={12} md={12}>
                        <Form.Group>
                            <Form.Label>Label</Form.Label>
                            <Form.Control type="text" maxLength={15} minLength={5} placeholder="Ex : Rumah, Kantor" value={addressLabel} onChange={(e) => setAddressLabel(e.target.value)} required />
                            <Form.Text>Max character (10). This cannot be filled in with an address, this is just an address label, such as Home, Work, etc.</Form.Text>
                        </Form.Group>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col>
                        <Form.Group>
                            <Form.Label>Sub District (Kecamatan)</Form.Label>
                            {
                                <>
                                    <AsyncSelect
                                        isClearable
                                        cacheOptions
                                        defaultOptions
                                        value={initialValue}
                                        // value={(editData) && { label: editData.destination, value: editData.destination }}
                                        loadOptions={promiseOptionsDestination}
                                        onChange={(value, action) => {
                                            setInitialValue(value);
                                            setIdDestination((value) ? value.value : null)
                                            setDestination((value) ? value.label : null)
                                            getZipCode((value) ? value.value : null)
                                        }}
                                        // value={(editData) && { label: editData.destination, value: editData.destination }}
                                        required
                                    />
                                    {
                                        optionDestnation.length == 0 &&
                                        <small className="text-primary"><Icon name="spinner" loading />Loading...</small>
                                    }
                                </>
                            }
                        </Form.Group>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col sm={12} md={12}>
                        <Form.Group>
                            <Form.Label>Zip Code</Form.Label>
                            <Form.Control type="text" value={zipCode} onChange={(e) => setZipCode(e.target.value)} maxLength={5} minLength={5} required />
                        </Form.Group>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col sm={12} md={12}>
                        <Form.Group>
                            <Form.Label>Address Detail</Form.Label>
                            <Form.Control type="textarea" maxLength={30} minLength={10} value={addressDetail} onChange={(e) => setAddressDetail(e.target.value)} required />
                            <Form.Text>Max Character (30) If it's not enough space, you can continue in "Additional Address Detail"</Form.Text>
                        </Form.Group>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col sm={12} md={12}>
                        <Form.Group>
                            <Form.Label>Additional Address Detail</Form.Label>
                            <Form.Control type="text" maxLength={30} value={addressDetailDua} onChange={(e) => setAddressDetailDua(e.target.value)} />
                            <Form.Text>Max Character (30)</Form.Text>
                        </Form.Group>
                    </Col>
                </Row>

                {/* {isCashier === '1' && (
                    <>
                        <hr></hr>
                        <Row className="mb-3">
                            <Col sm={12} md={12}>
                                <Form.Group>
                                    <Form.Label>Info Customer Name</Form.Label>
                                    <Form.Control type="text" maxLength={22} minLength={3} placeholder="Info Customer Name" value={infoName} onChange={(e) => setInfoName(e.target.value)} />
                                    <Form.Text>Max character (22)</Form.Text>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row className="mb-3">
                            <Col sm={12} md={12}>
                                <Form.Group>
                                    <Form.Label>Info Customer Email</Form.Label>
                                    <Form.Control type="text" minLength={3} placeholder="Info Customer Email" value={infoEmail} onChange={(e) => setInfoEmail(e.target.value)} />
                                    <Form.Text>Min character (3)</Form.Text>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row className="mb-3">
                            <Col sm={12} md={12}>
                                <Form.Group>
                                    <Form.Label>Info Customer Phone</Form.Label>
                                    <Form.Control type="number" maxLength={15} minLength={10} placeholder="Info Number" value={infoPhone} onChange={(e) => setInfoPhone(e.target.value)} />
                                </Form.Group>
                            </Col>
                        </Row>
                    </>
                )} */}

                {/* {(!isFirstAddress) ? (
                    <Row className="mb-3">
                        <Col sm={12} md={12}>
                            <Form.Group>
                                <Form.Check
                                    type="checkbox"
                                    label="Set Default"
                                    onChange={(e) => setIsDefault((e.target.checked === true) ? 1 : 0)}
                                    defaultChecked={editData.isDefault === "1" ? true : false}
                                    // disabled={(editData.isDefault === "1" && ) ? true : false}
                                    disabled
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                ) : <></>} */}

                <Row>
                    <Col sm={12} md={12} className="d-flex justify-content-between">
                        <Button
                            type="button"
                            size="large"
                            color="black"
                            icon="eraser"
                            disabled={isLoading}
                            onClick={handleReset}
                        >
                            Clear Form
                        </Button>
                        <Button loading={isLoading} content={editData ? "Update Address" : "Add Address"} floated="right" size="large" color="orange" type="submit" icon={editData ? "pencil" : "plus"} />
                    </Col>
                </Row>
            </Form>
        </section>
    )
}

export default AddressForm;